import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4468e998"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar is-transparent",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = { class: "navbar-item" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "icon-text has-text-success" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home fa-border" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-start buttons-container" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "navbar-end buttons-container"
}
const _hoisted_13 = {
  key: 0,
  class: "navbar-item"
}
const _hoisted_14 = { class: "field is-grouped" }
const _hoisted_15 = { class: "control" }
const _hoisted_16 = {
  key: 1,
  class: "navbar-item"
}
const _hoisted_17 = { class: "field is-grouped" }
const _hoisted_18 = { class: "control" }
const _hoisted_19 = {
  key: 2,
  class: "navbar-item"
}
const _hoisted_20 = { class: "field is-grouped" }
const _hoisted_21 = { class: "control" }
const _hoisted_22 = {
  key: 3,
  class: "navbar-item"
}
const _hoisted_23 = { class: "field is-grouped" }
const _hoisted_24 = { class: "control" }
const _hoisted_25 = {
  key: 4,
  class: "navbar-item"
}
const _hoisted_26 = { class: "field is-grouped" }
const _hoisted_27 = { class: "control" }
const _hoisted_28 = {
  key: 5,
  class: "navbar-item"
}
const _hoisted_29 = { class: "field is-grouped" }
const _hoisted_30 = { class: "control" }
const _hoisted_31 = {
  key: 6,
  class: "navbar-item"
}
const _hoisted_32 = { class: "field is-grouped" }
const _hoisted_33 = { class: "control" }
const _hoisted_34 = {
  key: 7,
  class: "navbar-item"
}
const _hoisted_35 = { class: "field is-grouped" }
const _hoisted_36 = { class: "control" }
const _hoisted_37 = {
  key: 8,
  class: "navbar-item"
}
const _hoisted_38 = { class: "field is-grouped" }
const _hoisted_39 = { class: "control" }
const _hoisted_40 = {
  key: 9,
  class: "navbar-item"
}
const _hoisted_41 = { class: "field is-grouped" }
const _hoisted_42 = { class: "control" }
const _hoisted_43 = {
  key: 10,
  class: "navbar-item"
}
const _hoisted_44 = { class: "field is-grouped" }
const _hoisted_45 = { class: "control" }
const _hoisted_46 = {
  key: 11,
  class: "navbar-item"
}
const _hoisted_47 = { class: "field is-grouped" }
const _hoisted_48 = { class: "control" }
const _hoisted_49 = {
  key: 12,
  class: "navbar-item"
}
const _hoisted_50 = { class: "field is-grouped" }
const _hoisted_51 = { class: "control" }
const _hoisted_52 = { class: "navbar-item" }
const _hoisted_53 = { class: "field is-grouped" }
const _hoisted_54 = { class: "control" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-6 h-6",
    width: "24",
    height: "24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.636 5.636a9 9 0 1012.728 0M12 3v9"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.iconPath,
          alt: "Wise Vet Live",
          height: "100%"
        }, null, 8, _hoisted_4)
      ]),
      (_ctx.getAccessType != 'newCustomer')
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToLandingScreen && _ctx.goToLandingScreen(...args)), ["prevent"])),
            class: "navbar-item"
          }, [
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Navbar.Start')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        role: "button",
        class: _normalizeClass(["navbar-burger", { 'is-active': _ctx.isNavbarOpen }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleNavbar && _ctx.toggleNavbar(...args))),
        "aria-label": "menu",
        "aria-expanded": "false",
        "data-target": "navMenu"
      }, _hoisted_10, 2)
    ]),
    _createElementVNode("div", {
      id: "navMenu",
      class: _normalizeClass(["navbar-menu", { 'is-active': _ctx.isNavbarOpen }])
    }, [
      _hoisted_11,
      (_ctx.getAccessType != 'newCustomer')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'vets' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, [
                      _createElementVNode("a", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchManagementMode('vets'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Veterinarians')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'managers' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, [
                      _createElementVNode("a", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchManagementMode('managers'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Managers')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'customers' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", _hoisted_21, [
                      _createElementVNode("a", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchManagementMode('customers'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Customers')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'appointments' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", _hoisted_24, [
                      _createElementVNode("a", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.switchManagementMode('appointments'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Appointments')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'products' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("p", _hoisted_27, [
                      _createElementVNode("a", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.switchManagementMode('products'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Products')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'logs' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, [
                      _createElementVNode("a", {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.switchManagementMode('logs'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Logs')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.useAppointsAccessCodes && _ctx.getAccessType == 'manager' && _ctx.getMngMode != 'appointments_access_codes' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("p", _hoisted_33, [
                      _createElementVNode("a", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.switchManagementMode('appointments_access_codes'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.AppointAccessCodes')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'vets_availability' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("p", _hoisted_36, [
                      _createElementVNode("a", {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.switchManagementMode('vets_availability'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.VetsAvailability')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'vet' && _ctx.getVetMode != 'availabilityconfig' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && _ctx.getHasAssociatedCalendar && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("p", _hoisted_39, [
                      _createElementVNode("a", {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.switchVetMode('availabilityconfig'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.AvailConfig')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'vet' && _ctx.getVetMode != 'availabilityslots' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && _ctx.getHasAssociatedCalendar && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("p", _hoisted_42, [
                      _createElementVNode("a", {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.switchVetMode('availabilityslots'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.AvailSlots')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'vet' && _ctx.getVetMode != 'appointments' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("p", _hoisted_45, [
                      _createElementVNode("a", {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.switchVetMode('appointments'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Appointments')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("p", _hoisted_48, [
                      _createElementVNode("a", {
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showUserdata && _ctx.showUserdata(...args))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.MyData')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getShowingUserData && !_ctx.getShowingPetRecord && !_ctx.getCustDetailing && !_ctx.getEditingCustomer && !(_ctx.getAccessType == 'vet' && !_ctx.getHasAssociatedCalendar) && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("p", _hoisted_51, [
                      _createElementVNode("a", {
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.endShowData && _ctx.endShowData(...args))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('General.Back')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("p", _hoisted_54, [
                  _createElementVNode("a", {
                    class: "button is-danger is-outlined",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.doLogout && _ctx.doLogout(...args)))
                  }, [
                    _hoisted_55,
                    _createTextVNode("   "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('Navbar.Logout')), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}